// extracted by mini-css-extract-plugin
module.exports = {"other_offers":"c6e8ba5398--other_offers--2E8wn"};